import styled from 'styled-components';

export const Table = styled.table`
	text-align: center;
	vertical-align: middle;
	border-radius: 16px;
	overflow: hidden;
	margin-top: 1rem;
	background-color: #fff;
	box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.16);
	font-size: 1.4rem;
	${({ theme }) => theme.common.wh('100%', 'auto')}

	th, td {
		border-collapse: collapse;
		padding: 1.5rem;
		white-space: nowrap;
		border: 1px solid ${({ theme }) => theme.color.regular};
	}
	th {
		background-color: ${({ theme }) => theme.color.lightGreen};
		${({ theme }) => theme.common.wh('40%', 'auto')}
	}
	td {
		${({ theme }) => theme.common.wh('60%', 'auto')}
	}
`;
